import { render, staticRenderFns } from "./SupportContactCard.vue?vue&type=template&id=bc0fa790"
import script from "./SupportContactCard.vue?vue&type=script&lang=js"
export * from "./SupportContactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports